import { useSelector } from 'react-redux';
import SlideButton from './components/web/SlideButton';
import { isSlideButtonEnabled } from './functions';
const slideButton = {
    key: 'slide-view',
    Content: SlideButton,
    group: 3
};
export function useSlideButton() {
    const enabled = useSelector(isSlideButtonEnabled);
    if (enabled) {
        return slideButton;
    }
}
